import React from "react";

import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import EditableTable from "../../../components/tables/EditableTable";
import LoadingGif from "../../../components/visual/LoadingGif";
import MainDateTimeInput from "../../../components/inputs/MainDateTimeInput";
import MainSelectInput from "../../../components/inputs/MainSelectInput";
import MainTabButton from "../../../components/inputs/MainTabButton";
import MainTextField from "../../../components/inputs/MainTextField";
import UserRepresentativePopup from "./UserRepresentativePopup";
import UserSalesRegionPopup from "./UserSalesRegionPopup";

import { Box, Button, Divider, FormControl, FormLabel, Grid, IconButton, Modal, Tab, Tabs } from "@mui/material";
import { defaultRequest } from "../../../utils/request/request";
import { handleChangeText } from "../../../utils/handleChange";


class UserRepresentedPopup extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoadingRegister: false,
            isLoadingSalesRegion: true,
            isLoadingRepresentedRegionTable: true,
            isLoadingRepresentedLocalSaleTable: true,

            isUserSalesRegionPopupOpen: false,
            isRepresentativePopupOpen: false,

            hasRepresented: false,

            represented: {
                idrepresentada: '',
                coderp: '',
                cnpj: '',
                usuario: {
                    coderp: '',
                    nome: '',
                }
            },

            mainLocalSaleOptions: [],

            representedLocalSaleObject: {},
            representedRegionList: [],
            representedRegionColumns: [
                ['desregiao', 'Nome da Região'],
                ['situacao', 'Situação'],
            ],
            representedRegionTotalSize: '',

            representedLocalSaleList: [],
            representedLocalSaleColumns: [
                ['cnpj', 'CNPJ'],
                ['razao', 'Razão'],
                ['localpadrao', 'Local Padrão'],
            ],
            representedLocalSaleTotalSize: '',

            activeTab: 0,

            statusOptions: [
                { 'value': 'A', 'label': 'Ativo' },
                { 'value': 'X', 'label': 'Cancelado' },
                { 'value': 'B', 'label': 'Bloqueado' },
            ],
        }
    }

    deleteRepresentedRegionTable = (id) => {
        let config = {
            method: 'delete',
            endpoint: 'represented/salesregion'
        }
        let form = {
            id: this.state.represented.idrepresentada,
            salesRegionId: id
        }
        defaultRequest(config, form).then((r) => {
            if (r.status) {
                this.props.showAlert(r.data.message, 'success')
                this.searchRepresentedRegion(0)
            } else {
                this.props.showAlert(r.data.message, 'error')
            }
        })
    }

    deleteRepresentedLocalSaleTable = (id) => {
        this.setState({ isLoadingSalesRegion: true })

        let config = {
            method: 'delete',
            endpoint: 'user/single/representative'
        }
        let form = {
            id: this.state.represented.idrepresentada,
            localSaleId: id
        }
        defaultRequest(config, form).then((r) => {
            if (r.status) {
                this.props.showAlert(r.data.message, 'success')
                this.fetchSalesRegion()
            } else {
                this.props.showAlert(r.data.message, 'error')
            }
        })
    }

    fetchSalesRegion = async () => {
        try {
            await Promise.all([
                this.searchRepresentedRegion(0),
                this.searchRepresentedLocalSale(),
                this.searchRepresentedLocalSaleOptions(0)
            ])

            this.setState({ isLoadingSalesRegion: false, isLoadingRepresentedLocalSaleTable: false  })
        } catch (error) {
            this.props.showAlert('An error occurred while fetching sales region', 'error')
            this.setState({ isLoadingSalesRegion: false })
        }
    }

    handleChangeMainLocalSale = () => {
        this.setState({ isLoadingSalesRegion: true })

        let config = {
            method: 'post',
            endpoint: 'represented/localsale/main'
        }

        let form = {
            id: this.state.represented.idrepresentada,
            localSaleId: this.state.mainLocalSale
        }

        defaultRequest(config, form).then((r) => {
            if (r.status) {
                this.fetchSalesRegion()
                this.props.showAlert(r.data.message, 'success')
            } else {
                this.setState({ isLoadingSalesRegion: false })
                this.props.showAlert(r.data.message, 'error')
            }
        })
    }

    handleChangeRepresentedStatus = async (event) => {
        this.setState({ isLoadingRegister: true })

        var represented = this.state.represented

        represented.situacao = represented.situacao === 'A' ? 'X' : 'A'

        let config = {
            method: 'post',
            endpoint: 'represented/status'
        }

        let form = {
            id: represented.idrepresentada,
            status: represented.situacao
        }
        try {
            const r = await defaultRequest(config, form)
            if (r.status) {
                this.setState({
                    represented: represented,
                    isLoadingRegister: false
                })
                this.props.showAlert(r.data.message, 'success')
            } else {
                this.props.showAlert('Erro ao alterar situacao de representada', 'error')
                this.setState({ isLoadingRegister: false })
            }
        } catch (err) {
            this.props.showAlert('error while handling represented', 'error')
            this.setState({ isLoadingRegister: false })
        }
    }

    handleChangeText = (event) => {
        this.setState({ [event.target.id]: event.target.value })
    }

    handleChangeTextRepresented = (event) => {
        handleChangeText(this.state.represented, event.target.id, event.target.value, () => this.forceUpdate())
    }

    handleChangeTextObject = (event) => {
        handleChangeText(this.state.representedLocalSaleObject, event.target.id, event.target.value, () => this.forceUpdate())
    }

    handleTabChange = (event, newValue) => {
        this.setState({ activeTab: newValue }, () => {
            if (newValue === 1) {
                this.setState({ isLoadingSalesRegion: true }, () => this.fetchSalesRegion())
            }
        })
    }

    includeRepresentedRegion = () => {
        this.setState({ isLoadingRepresentedRegionTable: true })

        if (!this.state.salesRegion) {
            this.props.showAlert('Selecione uma região para adicionar', 'error')
            return
        }

        let config = {
            method: 'post',
            endpoint: 'represented/salesregion'
        }

        let form = {
            id: this.state.represented.idrepresentada,
            salesRegionId: this.state.salesRegion,
        }
        defaultRequest(config, form).then((r) => {
            if (r.status) {
                this.props.showAlert(r.data.message, 'success')
                this.searchRepresentedRegion(0)
            } else {
                this.props.showAlert(r.data.message, 'error')
                this.setState({ isLoadingRepresentedRegionTable: false })
            }
        })
    }

    includeRepresentedLocalSale = () => {
        this.setState({ isLoadingSalesRegion: true })

        if (!this.state.localSale) {
            this.props.showAlert('Selecione um local de venda para adicionar', 'error')
            this.setState({ isLoadingRepresentedLocalSaleTable: false })
            return
        }

        let config = {
            method: 'post',
            endpoint: 'user/single/representative'
        }
        let form = {
            representedId: this.state.represented.idrepresentada,
            localSaleId: this.state.localSale

        }
        defaultRequest(config, form).then((r) => {
            if (r.status) {
                this.props.showAlert(r.data.message, 'success')
                this.fetchSalesRegion()
            } else {
                this.props.showAlert(r.data.message, 'error')
            }
        })
    }

    onRepresentedRegionTableEdit = (row, method, id) => {
        if (method === 'delete') {
            this.setState({
                representedRegionList: row
            }, () => this.deleteRepresentedRegionTable(id))
        }
    }

    onRepresentedLocalSaleTableEdit = (row, method, id) => {
        if (method === 'delete') {
            this.setState({
                representedLocalSaleList: row
            }, () => this.deleteRepresentedLocalSaleTable(id))
        }
    }

    renderRegister = () => {
        if (this.state.isLoadingRegister) {
            return (
                <LoadingGif />
            )
        }
        return (
            <Grid container columnSpacing={1} rowSpacing={2} sx={{ flexDirection: { xs: 'column', sm: 'column', md: 'row' }, marginTop: '10px' }}>
                <Grid item md={2}><MainTextField required {...this.props} type='number' id='coderp' value={this.state.represented.coderp} label='Código ERP' handleChange={this.handleChangeTextRepresented} width='100%' /></Grid>
                <Grid item md={3}><MainTextField required {...this.props} type='number' id='cnpj' value={this.state.represented.cnpj} label='CNPJ' handleChange={this.handleChangeTextRepresented} width='100%' /></Grid>
                <Grid item md={5}><MainTextField {...this.props} id='fantasia' value={this.state.represented.fantasia} label='Fantasia' disabled={true} width='100%' /></Grid>
                <Grid item md={2}><Button sx={{ background: this.props.colors.custom['searchButtons'], width: '100%', height: '100%' }} {...this.props} variant='contained' onClick={this.searchRepresented}>Buscar</Button></Grid>

                <Grid item md={12}><Divider /></Grid>

                <Grid item md={7}><MainTextField {...this.props} id='razao' value={this.state.represented.razao} label='Razão Social' disabled={true} width='100%' /></Grid>
                <Grid item md={3}><MainSelectInput {...this.props} id='situacao' value={this.state.represented.situacao} optionsList={this.state.statusOptions} label='Situação' disabled={true} width='100%' /></Grid>
                <Grid item md={2}>
                    <MainTabButton {...this.props} title={this.state.represented.situacao === 'A' ? 'Inativar' : 'Ativar'} onButtonClick={this.handleChangeRepresentedStatus} sx={{ width: { xs: '100%', sm: '100%', md: '100%' } }} />
                </Grid>

                <Grid item md={3}><MainTextField {...this.props} id='cep' value={this.state.represented.cep} label='CEP' disabled={true} width='100%' /></Grid>
                <Grid item md={5}><MainTextField {...this.props} id='logradouro' value={this.state.represented.logradouro} label='Logradouro' disabled={true} width='100%' /></Grid>
                <Grid item md={2}><MainTextField {...this.props} id='numero' value={this.state.represented.numero} label='Número' disabled={true} width='100%' /></Grid>
                <Grid item md={2}><MainTextField {...this.props} id='complemento' value={this.state.represented.complemento} label='Complemento' disabled={true} width='100%' /></Grid>

                <Grid item md={2}><MainTextField {...this.props} id='bairro' value={this.state.represented.bairro} label='Bairro' disabled={true} width='100%' /></Grid>
                <Grid item md={4}><MainTextField {...this.props} id='cidade' value={this.state.represented.cidade} label='Cidade' disabled={true} width='100%' /></Grid>
                <Grid item md={3}><MainTextField {...this.props} id='telfixo' value={this.state.represented.telfixo} label='Telefone Fixo' disabled={true} width='100%' /></Grid>
                <Grid item md={3}><MainTextField {...this.props} id='telcelular' value={this.state.represented.telcelular} label='Telefone Celular' disabled={true} width='100%' /></Grid>
                <Grid item md={2}><MainTextField {...this.props} id='whatsapp' value={this.state.represented.whatsapp} label='WhatsApp' disabled={true} width='100%' /></Grid>

                <Grid item md={2}><MainDateTimeInput {...this.props} id='datafundacao' value={this.state.represented.datafundacao} label='Fundação' disabled={true} type='date' width='100%' /></Grid>
                <Grid item md={4}><MainTextField {...this.props} id='email' value={this.state.represented.email} label='E-mail' disabled={true} width='100%' /></Grid>
                <Grid item md={2}><MainTextField {...this.props} id='inscestadual' value={this.state.represented.inscestadual} label='Inscrição Estadual' disabled={true} width='100%' /></Grid>
                <Grid item md={2}><MainTextField {...this.props} id='inscmunicipal' value={this.state.represented.inscmunicipal} label='Inscrição Municipal' disabled={true} width='100%' /></Grid>

                <Grid item md={6}>
                    <FormControl fullWidth sx={{ display: 'flex', flexDirection: 'row', gap: '10px', padding: '15px', borderRadius: '5px', border: `1px solid ${this.props.colors.grey[800]}`, position: 'relative' }}>
                        <FormLabel sx={{ position: 'absolute', top: '-10px', left: '10px', backgroundColor: 'white', padding: '0 5px', color: 'gray', fontSize: '0.9rem' }}>
                            Usuário Vinculado
                        </FormLabel>
                        <MainTextField {...this.props} id='usuario.coderp' value={this.state.represented.usuario.coderp} label='Usuário ERP' disabled={true} width='60%' />
                        <MainTextField {...this.props} id='usuario.nome' value={this.state.represented.usuario.nome} label='Nome do Usuário' disabled={true} width='100%' />
                    </FormControl>
                </Grid>

                <Grid item md={3}></Grid>

                <Grid item md={3}><Button sx={{ background: this.props.colors.custom['searchButtons'], width: '100%', height: '60%' }} {...this.props} variant='contained' onClick={() => this.setState({ isRepresentativePopupOpen: true })} disabled={this.state.hasRepresented ? false : true}>Visualizar Representantes</Button></Grid>

                {this.state.isRepresentativePopupOpen && (
                    <UserRepresentativePopup
                        {...this.props}
                        {...this.state}
                        isOpen={this.state.isRepresentativePopupOpen}
                        closePopup={() => this.setState({ isRepresentativePopupOpen: false })}
                    />
                )}
            </Grid>
        )
    }

    renderSalesRegion = () => {
        console.log(this.props)
        if (this.state.isLoadingSalesRegion) {
            return (
                <LoadingGif />
            )
        }
        return (
            <Grid container columnSpacing={3} rowSpacing={2} sx={{ flexDirection: { xs: 'column', sm: 'column', md: 'row' }, marginTop: '10px' }}>
                <Grid item md={2}><MainTextField {...this.props} id='coderp' value={this.state.represented.coderp} label='Código ERP' disabled={true} width='100%' /></Grid>
                <Grid item md={3}><MainTextField {...this.props} id='cnpj' value={this.state.represented.cnpj} label='CNPJ' disabled={true} width='100%' /></Grid>
                <Grid item md={7}><MainTextField {...this.props} id='fantasia' value={this.state.represented.fantasia} label='Fantasia' disabled={true} width='100%' /></Grid>

                <Grid item md={12}><Divider /></Grid>

                <Grid item md={6}>
                    <Grid container columnSpacing={1} rowSpacing={2} sx={{ flexDirection: { xs: 'column', sm: 'column', md: 'row' } }}>
                        <Grid item md={8}><MainSelectInput {...this.props} id='idrepresentada.idpolcomissao' value={this.state.representedLocalSaleObject.idrepresentada.idpolcomissao} optionsList={this.props.comissionPolicyOptions} label='Política de Comissão' handleChange={this.handleChangeTextObject} width='100%' /></Grid>
                        <Grid item md={4}><Button {...this.props} variant='contained' onClick={() => this.setState({ isUserSalesRegionPopupOpen: true })} disabled={this.state.representedLocalSaleObject.idrepresentada.idpolcomissao ? false : true} sx={{ background: this.props.colors.custom['searchButtons'], width: '94%', height: '100%' }}>Visualizar</Button></Grid>


                        {this.state.isUserSalesRegionPopupOpen && (
                            <UserSalesRegionPopup
                                {...this.props}
                                {...this.state}
                                isOpen={this.state.isUserSalesRegionPopupOpen}
                                closePopup={() => this.setState({ isUserSalesRegionPopupOpen: false })}
                                handleChangeText={this.handleChangeText}
                                comissionPolicyId={this.state.representedLocalSaleObject.idrepresentada.idpolcomissao}
                            />
                        )}

                        <Grid item md={8}><MainSelectInput {...this.props} id='salesRegion' value={this.state.salesRegion} optionsList={this.props.salesRegionOptions} label='Regiões de vendas' handleChange={this.handleChangeText} width='100%' /></Grid>
                        <Grid item md={4}>
                            <MainTabButton {...this.props} onButtonClick={this.includeRepresentedRegion} title="Inserir" sx={{ width: { xs: '100%', sm: '100%', md: '95%' } }} />
                        </Grid>

                        <Grid item md={12}>
                            <EditableTable
                                {...this.props}
                                allowEdit
                                noEditButton
                                height='25vh'
                                customMargin='10px 0 0 0'
                                id='idregiao'
                                data={this.state.representedRegionList}
                                columns={this.state.representedRegionColumns}
                                rowId='idregiao'
                                totalSize={this.state.representedRegionTotalSize}
                                onPageChange={this.searchRepresentedRegion}
                                onEditRow={this.onRepresentedRegionTableEdit}
                                onRowDoubleClick={() => { }}
                                isLoading={this.state.isLoadingRepresentedRegionTable}
                            />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item md={6}>
                    <Grid container columnSpacing={1} rowSpacing={2} sx={{ flexDirection: { xs: 'column', sm: 'column', md: 'row' } }}>
                        <Grid item md={6}><MainSelectInput {...this.props} id='idrepresentada.idlinha' value={this.state.representedLocalSaleObject.idrepresentada.idlinha} optionsList={this.props.productLineOptions} label='Linha de Produtos' handleChange={this.handleChangeTextObject} width='100%' /></Grid>
                        <Grid item md={6}><MainSelectInput {...this.props} id='idrepresentada.idequipe' value={this.state.representedLocalSaleObject.idrepresentada.idequipe} optionsList={this.props.saleTeamOptions} label='Equipe' handleChange={this.handleChangeTextObject} width='100%' /></Grid>

                        <Grid item md={8}><MainSelectInput {...this.props} id='localSale' value={this.state.localSale} optionsList={this.props.localSaleOptions} label='Local de Venda' handleChange={this.handleChangeText} width='100%' /></Grid>
                        <Grid item md={4}>
                            <MainTabButton {...this.props} onButtonClick={this.includeRepresentedLocalSale} title="Inserir" sx={{ width: { xs: '100%', sm: '100%', md: '100%' } }} />
                        </Grid>

                        <Grid item md={12}>
                            <EditableTable
                                {...this.props}
                                allowEdit
                                // allowEditOnRow
                                noEditButton
                                height='25vh'
                                customMargin='10px 0 0 0'
                                id='idlocalvenda'
                                data={this.state.representedLocalSaleList}
                                columns={this.state.representedLocalSaleColumns}
                                rowId='idlocalvenda'
                                totalSize={this.state.representedLocalSaleTotalSize}
                                onPageChange={this.searchRepresentedLocalSale}
                                onEditRow={this.onRepresentedLocalSaleTableEdit}
                                onRowDoubleClick={() => { }}
                                isLoading={this.state.isLoadingRepresentedLocalSaleTable}
                                extraColumnsConfig={
                                    {
                                        'cnpj': {
                                            'disabled': true,
                                        },
                                        'razao': {
                                            'disabled': true,
                                        },
                                        'localpadrao': {
                                            'type': 'select',
                                            'options': this.props.localpadraoOptions
                                        },
                                    }
                                }
                            />
                        </Grid>

                        <Grid item md={8}><MainSelectInput {...this.props} id='mainLocalSale' value={this.state.mainLocalSale} optionsList={this.state.mainLocalSaleOptions} label='Local Padrão' handleChange={this.handleChangeText} width='100%' /></Grid>
                        <Grid item md={4}><Button {...this.props} variant='contained' onClick={this.handleChangeMainLocalSale} disabled={this.state.mainLocalSale ? false : true} sx={{ background: this.props.colors.custom['searchButtons'], width: '100%', height: '100%' }}>Salvar</Button></Grid>

                    </Grid>
                </Grid>
            </Grid>
        )
    }

    searchRepresented = () => {
        this.setState({ isLoadingRegister: true })

        let config = {
            method: 'get',
            endpoint: 'user/single/represented'
        }

        let form = {
            coderp: this.state.represented.coderp,
            cnpj: this.state.represented.cnpj,
        }
        defaultRequest(config, form).then((r) => {
            if (r.status) {
                this.setState({
                    represented: r.data.represented,

                    isLoadingRegister: false,
                    hasRepresented: true,
                }, () => this.props.showAlert(r.data.message, 'success'))
            } else {
                this.setState((prevState) => ({
                    isLoadingRegister: false,
                    hasRepresented: false,

                    represented: Object.keys(prevState.represented).reduce((acc, key) => {
                        acc[key] = ''
                        return acc
                    }, {}),
                }), () => this.props.showAlert(r.data.message, 'error'))
            }
        })
    }

    searchRepresentedRegion = async (page) => {
        let config = {
            method: 'get',
            endpoint: 'represented/salesregion'
        }
        let form = {
            id: this.state.represented.idrepresentada,
            page: page
        }
        try {
            const r = await defaultRequest(config, form)
            if (r.status) {
                this.setState({
                    representedRegionList: r.data.sales_region,
                    representedRegionTotalSize: r.data.total_size,

                    isLoadingRepresentedRegionTable: false,
                })
            } else {
                this.props.showAlert(r.data.message, 'error')
                this.setState({ isLoadingRepresentedRegionTable: false })
            }
        } catch (error) {
            console.log('error while fetching region')
            this.setState({ isLoadingRepresentedRegionTable: false })
        }
    }

    searchRepresentedLocalSale = async () => {
        let config = {
            method: 'get',
            endpoint: 'user/single/representative',
        }
        let form = {
            id: this.props.selectedRow.idusuario,
        }
        try {
            const r = await defaultRequest(config, form)
            if (r.status) {
                this.setState({
                    representedLocalSaleObject: r.data.representativeObject,
                    representedLocalSaleList: r.data.representativeObject.idrepresentada.local,
                    representedLocalSaleTotalSize: r.data.representativeObject.idrepresentada.local.length,
                })
            } else {
                this.props.showAlert(r.data.message, 'error')
            }
        } catch (error) {
            console.log('error while fetching localsale')
        }
    }

    searchRepresentedLocalSaleOptions = async (page) => {
        let config = {
            method: 'get',
            endpoint: 'represented/localsale'
        }
        let form = {
            id: this.state.represented.idrepresentada,
            page: page
        }
        try {
            const r = await defaultRequest(config, form)
            if (r.status) {
                this.setState({
                    mainLocalSale: r.data.main_local_sale?.idlocalvenda,
                    mainLocalSaleOptions: r.data.main_local_sale_option,
                })
            } else {
                this.setState({
                    mainLocalSale: '',
                    mainLocalSaleOptions: [],
                })
            }
        } catch (error) {
            console.log('error while fetching localsale')
        }
    }


    render() {
        return (
            <Modal open={this.props.isOpen} onClose={this.props.closePopup} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Box style={styles.popUpContainer}>

                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Tabs value={this.state.activeTab} onChange={this.handleTabChange}>
                            <Tab label="Cadastro" />
                            {this.state.hasRepresented
                                ? <Tab label="Região de Vendas" />
                                : <></>
                            }

                        </Tabs>
                        <IconButton onClick={this.props.closePopup}>
                            <CloseOutlinedIcon />
                        </IconButton>
                    </Box>

                    <Box sx={{ mt: 2 }}>
                        {this.state.activeTab === 0 && this.renderRegister()}
                        {this.state.activeTab === 1 && this.renderSalesRegion()}
                    </Box>
                </Box>
            </Modal>
        )
    }
}

export default UserRepresentedPopup;

const styles = {
    popUpContainer: {
        backgroundColor: 'white',
        borderRadius: '10px',
        padding: '20px',
        width: '100%',
        height: '65vh',
        maxWidth: '1400px',
        maxHeight: '90vh',
        overflowY: 'auto',
    },
}